
















import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import LatestResultsWidget from '@/shared/components/LatestResultsWidget.vue';
import { Busy } from '@/components/Busy.ts';
import { leagueModuleName } from '@/modules/league/store/index';
import { Actions as LeagueActions } from '@/modules/league/store/actions';
import { Getters as LeagueGetters } from '@/modules/league/store/getters';
import { LastMatchDayResultsWidgetState } from '../models/LastMatchDayResultsWidgetModel';
import { MatchResultModel } from '../models/MatchResultModel';
import { Settings, Season } from '../store/models';
const leagueModule = namespace(leagueModuleName);

import moment from 'moment';
import { MatchDayResultsModel } from '../models/MatchDayResultsModel';

@Component({
  components: {
    LatestResultsWidget,
  },
})
export default class LastMatchDayResultsWidget extends Vue {

  private busy: Busy = new Busy();

  @leagueModule.Getter(LeagueGetters.LAST_MATCH_DAY_RESULTS_WIDGET_STATE) private lastMatchDayReultsWidgetState!: LastMatchDayResultsWidgetState;
  @leagueModule.Action(LeagueActions.FETCH_LAST_MATCH_DAY_RESULTS_WIDGET) private fetchLastMatchDayResultsWidget!: (fetchMatchResultsInput: any) => any;
  @leagueModule.Getter(LeagueGetters.LAST_MATCH_DAY_RESULTS) private lastMatchDayResults!: MatchDayResultsModel;

  @leagueModule.Action(LeagueActions.FETCH_LEAGUE_SETTINGS) private fetchLeagueSettings!: () => any;
  @leagueModule.Getter(LeagueGetters.LOADED) private settingsLoaded!: number;
  @leagueModule.Getter(LeagueGetters.ACTIVE_SEASON) private activeSeason!: Season;

  public async mounted() {
    await this.loadData();
  }

  private async loadData() {
    await this.ensureLeagueSettingsIsLoaded().then(async () => {
      await this.ensureLastMatchDayResultsAreLoaded();
    });
  }

  private async ensureLeagueSettingsIsLoaded() {
    if (!this.settingsLoaded) {
      this.busy.SetBusy();
      await this.fetchLeagueSettings().then(() => {
        this.busy.SetFree();
      });
    }
  }

  private async ensureLastMatchDayResultsAreLoaded() {
    if (!this.lastMatchDayReultsWidgetState.isFetched) {
      this.busy.SetBusy();
      await this.fetchLastMatchDayResultsWidget({ seasonId: this.activeSeason.id}).then(() => {
        this.busy.SetFree();
      });
    }
  }

  get isBusy() {
    return this.busy.isBusy || !this.lastMatchDayReultsWidgetState.isFetched;
  }

}
